var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBullseye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78125 3.59375L10.2812 5.15625L7.46875 8C7.15625 8.28125 7.15625 8.75 7.46875 9.03125C7.75 9.34375 8.21875 9.34375 8.5 9.03125L11.3438 6.21875L12.9062 6.71875C13.125 6.8125 13.375 6.75 13.5625 6.5625L15.5312 4.59375C15.875 4.25 15.75 3.6875 15.2812 3.53125L13.5625 2.9375L12.9688 1.21875C12.8125 0.75 12.25 0.625 11.9062 0.96875L9.9375 2.9375C9.8125 3.0625 9.71875 3.21875 9.71875 3.40625C9.71875 3.46875 9.75 3.53125 9.78125 3.59375ZM7.40625 6.59375L9.15625 4.875L9.0625 4.6875C8.71875 4.59375 8.375 4.5 8 4.5C5.78125 4.5 4 6.3125 4 8.5C4 10.7188 5.78125 12.5 8 12.5C10.1875 12.5 12 10.7188 12 8.5C12 8.125 11.9062 7.78125 11.8125 7.4375L11.625 7.34375L9.90625 9.09375C9.65625 9.90625 8.875 10.5 8 10.5C6.875 10.5 6 9.625 6 8.5C6 7.625 6.59375 6.84375 7.40625 6.59375ZM15.375 6.1875L14.25 7.28125C14.0938 7.46875 13.875 7.59375 13.6562 7.65625C13.7188 7.9375 13.75 8.21875 13.75 8.5C13.75 11.6875 11.1562 14.25 8 14.25C4.8125 14.25 2.25 11.6875 2.25 8.5C2.25 5.34375 4.8125 2.75 8 2.75C8.28125 2.75 8.5625 2.78125 8.84375 2.84375C8.9375 2.625 9.03125 2.40625 9.21875 2.25L10.3125 1.125C9.59375 0.90625 8.8125 0.78125 8 0.78125V0.75C3.71875 0.75 0.25 4.25 0.25 8.5C0.25 12.7812 3.71875 16.25 8 16.25C12.25 16.25 15.75 12.7812 15.75 8.5C15.75 7.6875 15.5938 6.90625 15.375 6.1875Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.9e79021acf0c6c7f29e94e4f4fb49530.svg";
export { ForwardRef as ReactComponent };